var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralHouse = function SvgGeneralHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 65"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.694 16.05 34.361 2.719a11.25 11.25 0 0 0-14.667 0L4.334 16.05a11.7 11.7 0 0 0-4 8.88v22.32a6.133 6.133 0 0 0 6.054 6.133h9.066a6.107 6.107 0 0 0 6.214-6.133V35.73a5.68 5.68 0 0 1 4.533-5.654 5.333 5.333 0 0 1 6.346 5.334v11.84a6.107 6.107 0 0 0 6 6.133h9.067a6.133 6.133 0 0 0 6.054-6.133V24.904a11.76 11.76 0 0 0-3.974-8.853"
  })));
};
export default SvgGeneralHouse;